var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("aside", { staticClass: "right-side" }, [
    _c(
      "section",
      { staticClass: "content-header" },
      [
        _vm.header ? _c("h1", [_vm._v(_vm._s(_vm.header))]) : _vm._e(),
        _vm._v(" "),
        _c("breadcrumbs")
      ],
      1
    ),
    _vm._v(" "),
    _c("section", { staticClass: "content" }, [_c("router-view")], 1)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }